export default "__VITE_ASSET__202c7150__"